import {isDev} from '@/utils/env'

type GuidexEnvironment = 'production' | 'preview' | 'development'

const GUIDEX_ENVIRONMENTS: readonly string[] = ['production', 'preview', 'development']

/**
 * VITE_GUIDEX_ENV is replaced at container start (see entry.sh). When a deployment
 * doesn't define it the placeholder stays as-is, so fall back to showing only published tours.
 */
export const getGuidexEnvironment = (value: unknown = import.meta.env.VITE_GUIDEX_ENV): GuidexEnvironment => {
  if (typeof value === 'string' && GUIDEX_ENVIRONMENTS.includes(value)) {
    return value as GuidexEnvironment
  }
  return isDev() ? 'development' : 'production'
}
